.popover {
    background-color: white;
    border: 1px solid #ccc;
    padding: 10px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    position: relative
  }
  